import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Lock, CheckCircle2, AlertTriangle } from "lucide-react";
import { WalkthroughItemCard } from "./WalkthroughItemCard";
import { fmtDateTime } from "./imageUtils";

const Row = ({ label, children, testId }) => (
  <div className="flex flex-col sm:flex-row sm:gap-4 py-1.5">
    <dt className="sm:w-40 text-sm text-slate-500 shrink-0">{label}</dt>
    <dd className="text-sm font-medium text-slate-900" data-testid={testId}>{children}</dd>
  </div>
);

export const WalkthroughRecord = ({ wt }) => {
  const ack = wt.acknowledgement || {};
  const client = wt.client || {};
  return (
    <div className="space-y-5" data-testid="walkthrough-record">
      <Card className="dashboard-card">
        <CardHeader><CardTitle className="flex items-center gap-2 text-lg"><Lock className="w-5 h-5 text-slate-500" />Walkthrough Record</CardTitle></CardHeader>
        <CardContent>
          <dl>
            <Row label="Walkthrough">{fmtDateTime(wt.started_at)}</Row>
            <Row label="Finished">{fmtDateTime(wt.finished_at)}</Row>
            <Row label="Site Manager">{wt.started_by_name}</Row>
            <Row label="Client">{client.company_name ? `${client.company_name} — ` : ""}{client.name} ({client.client_type === "developer" ? "Developer" : "Purchaser"})</Row>
            <Row label="Items recorded" testId="record-item-count">{wt.item_count}</Row>
            <Row label="Acknowledged" testId="record-ack-status">
              {ack.acknowledged
                ? <span className="inline-flex items-center gap-1 text-green-700"><CheckCircle2 className="w-4 h-4" />{fmtDateTime(ack.signed_at)} — {ack.client_name}</span>
                : <span className="inline-flex items-center gap-1 text-amber-700"><AlertTriangle className="w-4 h-4" />Not acknowledged</span>}
            </Row>
          </dl>
          {ack.acknowledged && ack.signature_data && (
            <img src={ack.signature_data} alt="Client signature" className="mt-3 h-24 rounded-md border border-slate-200 bg-white" data-testid="record-signature" />
          )}
        </CardContent>
      </Card>

      <div className="space-y-2">
        <h2 className="font-semibold text-slate-800">Items recorded during the walkthrough{wt.removed_count ? ` (${wt.removed_count} removed since)` : ""}</h2>
        {wt.items.map((it, i) => <WalkthroughItemCard key={it.defect_id} item={it} index={i} />)}
      </div>

      {wt.added_after?.length > 0 && (
        <div className="space-y-2" data-testid="record-added-after">
          <h2 className="font-semibold text-slate-800">Added after walkthrough</h2>
          {wt.added_after.map((it, i) => <WalkthroughItemCard key={it.id} item={it} index={i} tag="Added after walkthrough" />)}
        </div>
      )}
    </div>
  );
};
